module.exports = __webpack_public_path__ + "static/schibsted-logo-74cf9ef2a02a82ec55c2ab8c88d6e2ce.png";